import {
  FOLLOW_CATCH_UP_DISTANCE_PX,
  FOLLOW_SLOT_BEHIND_PX,
  FOLLOW_SLOT_LATERAL_PX,
} from "@cold-case/shared/player-follow";

import type { PlayableDir } from "./playable-facing.js";

const DIR_VEC: Record<PlayableDir, { x: number; y: number }> = {
  north: { x: 0, y: -1 },
  south: { x: 0, y: 1 },
  east: { x: 1, y: 0 },
  west: { x: -1, y: 0 },
  "north-east": { x: 0.707, y: -0.707 },
  "north-west": { x: -0.707, y: -0.707 },
  "south-east": { x: 0.707, y: 0.707 },
  "south-west": { x: -0.707, y: 0.707 },
};

/** Slot behind the leader; slot 0 centered, slot 1 offset laterally. */
export function followSlotWorldPosition(
  leaderX: number,
  leaderY: number,
  facing: PlayableDir,
  slotIndex: number
): { x: number; y: number } {
  const f = DIR_VEC[facing] ?? DIR_VEC.south;
  const behindX = -f.x;
  const behindY = -f.y;
  const lateralX = -f.y;
  const lateralY = f.x;
  const lateralSign = slotIndex === 1 ? 1 : slotIndex === 0 ? 0 : -1;
  return {
    x: leaderX + behindX * FOLLOW_SLOT_BEHIND_PX + lateralX * FOLLOW_SLOT_LATERAL_PX * lateralSign,
    y: leaderY + behindY * FOLLOW_SLOT_BEHIND_PX + lateralY * FOLLOW_SLOT_LATERAL_PX * lateralSign,
  };
}

export function followMoveSpeedPxS(
  distToSlot: number,
  baseSpeedPxS: number
): number {
  if (distToSlot > FOLLOW_CATCH_UP_DISTANCE_PX) return baseSpeedPxS * 2;
  return baseSpeedPxS;
}
